import * as actionTypes from './actionTypes';
import axios from "axios"

// *********************************** FEATURED VEHICLES **************************:

export const initGetFeaturedVehicles = () => {
    return {
        type: actionTypes.INIT_GET_FEATURED_VEHICLS,
        loadingFeature: true,
        commingSoon : false
    }
};

export const fetchFeaturedVehicle = (data) => {
    return {
        type: actionTypes.GET_FEATURED_VEHICELS,
        feauredVechils: data,
        loadingFeature: false,
        commingSoon : false
    }
};

export const failFetchFeaturedVehicle = (error) => {
    return {
        type: actionTypes.Fail_GET_FEATURED_VEHILELS,
        errorFeaturedVehicls: error.message,
        commingSoon : false
    }
};

export const showCommingSoon = (error) => {
    return {
        type: actionTypes.COMMING_SOON,
        commingSoon : true
    }
};

export const getFeaturedVehicle = (type) => {
    return dispatch => {
        if (type === 'cars' || type === 'motors' || type === 'commercials' || type === 'all') {
            dispatch(initGetFeaturedVehicles())
            axios.get(`${type}/lists?is_featured=1`)
                .then(response => {
                    const featureVehicle = response.data.data.slice(0, 4)
                    dispatch(fetchFeaturedVehicle(featureVehicle))
                })
                .catch(error => {
                    dispatch(failFetchFeaturedVehicle(error))
                })
        }
        else{
            dispatch(showCommingSoon())
        }
    }

};

// *********************************** FEATURED DEALERS *************************************** :


export const initGetFeaturedDealers = () => {
    return {
        type: actionTypes.INIT_GET_FEATURED_DEALERS,
        loadingDealers: true,
    }
};

export const fetchFeaturedDealers = (data) => {
    return {
        type: actionTypes.GET_FEATURED_DEALERS,
        feauredDealers: data,
        loadingDealers: false,
    }
};

export const failFetchFeaturedDealers = (error) => {
    return {
        type: actionTypes.Fail_GET_FEATURED_DEALERS,
        errorDealers: error.message
    }
};

export const getFeaturedDealers = () => {
    return dispatch => {
        dispatch(initGetFeaturedDealers())
        axios.get('dealers/featured')
            .then(response => {
                const featureDealers = response.data.data.slice(0, 8)
                dispatch(fetchFeaturedDealers(featureDealers))
            })
            .catch(error => {
                dispatch(failFetchFeaturedDealers(error))
            })
    }
};